export interface Game {
  id: string;
  name: string;
  shortName?: string;
  quests: Record<string, string>;
  ab: string;
  banner: string | undefined;
  rating: number | undefined;
  downloads: string | undefined;
  iOS: string;
  Android: string;
  Windows?: string;
  General?: string;
  genre?: string[];
  description?: string;
}

export const GAMES = {
  mtdz: {
    id: "da200b52-f706-433d-8617-03c35d02cdfe",
    quests: {
      loginPlayGame: "login-play-game",
      wishlist: "da200b52-f706-433d-8617-03c35d02cdfe0-wishlist",
    },
    name: "MetaToy DragonZ Saga",
    shortName: "MetaToy",
    ab: "/games/mtdz",
    banner: "/images/onboarding/meta-toy-banner.webp",
    rating: 4.0,
    downloads: "100k",
    iOS: "https://apps.apple.com/us/app/meta-toy-dragonz-saga/id6748107724",
    Android:
      "https://play.google.com/store/apps/details?id=com.sandboxgame.mtdsaga",
  },
  gog: {
    id: "8bbf049c-5ffb-4e1a-8e28-086397627dde",
    quests: {
      loginPlayGame: "login-play-game",
    },
    name: "Guild of Guardians",
    ab: "/games/guild-of-guardians",
    banner: undefined,
    rating: undefined,
    downloads: undefined,
    iOS: "https://apps.apple.com/app/guild-of-guardians/id1574135647",
    Android:
      "https://play.google.com/store/apps/details?id=com.immutable.guildofguardians",
  },
  diceGo: {
    id: "f6f6725a-8c1e-4cf3-8a88-bb88804f894e",
    quests: {
      wishlist: "f6f6725a-8c1e-4cf3-8a88-bb88804f894e-wishlist",
      loginPlayGame: "login-play-game",
    },
    name: "Dice Go",
    ab: "/games/dice-go",
    banner: "/images/onboarding/dice-go-banner.webp",
    rating: undefined,
    downloads: undefined,
    iOS: "https://apps.apple.com/app/dice-go-the-showdown/id6747158625",
    Android: "https://play.google.com/store/apps/details?id=com.ntriple.dicego",
    General: "https://ntiny.link/dicego2",
    description: "Dice Go is here to test your strategy and build fortune.",
  },
  immortalRising2: {
    id: "96191677-0a86-4718-a863-d8e7818fc063",
    quests: {
      wishlist: "96191677-0a86-4718-a863-d8e7818fc063-wishlist",
      loginPlayGame: "login-play-game",
      downloadPlay: "q-download-play",
    },
    name: "Immortal Rising 2",
    genre: ["RPG"],
    ab: "/games/immortal-rising-2",
    banner: "/images/onboarding/immortal-rising-2-banner.webp",
    rating: undefined,
    downloads: undefined,
    iOS: "https://apps.apple.com/app/immortal-rising-2/id6467105374",
    Android:
      "https://play.google.com/store/apps/details?id=com.badbeans.immortalrising2",
    description: "Experience guild wars and compete for epic rewards",
  },
  eightBall: {
    id: "925b48b9-fb2f-4bb0-9054-700eb9cf51eb",
    quests: {
      wishlist: "8ball-wishlist",
    },
    name: "8 Ball Pool",
    shortName: "8 Ball",
    ab: "/games/8-ball",
    banner: "/images/onboarding/8-ball-pool-banner.webp",
    rating: 4.5,
    downloads: "500k+",
    iOS: "https://apps.apple.com/app/8-ball-by-pokerist/id6738424044",
    Android:
      "https://play.google.com/store/apps/details?id=com.kamagames.billiard&hl=en",
    Windows: "https://store.steampowered.com/app/3760100/8_Ball_by_Pokerist/",
  },
  warp: {
    id: "5bbcb20b-1295-4888-b64c-9bac69972a76",
    quests: {
      wishlist: "wishlist",
    },
    shortName: "Warp",
    name: "Warp",
    ab: "/games/warp",
    banner: undefined,
    rating: undefined,
    downloads: undefined,
    iOS: "",
    Android: "",
    Windows: undefined,
  },
  devilfish: {
    id: "b4ba6785-c93b-4d06-a415-1a23e52018aa",
    quests: {
      wishlist: "follow-devilfish",
    },
    shortName: "Devilfish",
    name: "Devilfish",
    ab: "/games/devilfish",
    banner: undefined,
    rating: undefined,
    downloads: undefined,
    iOS: "",
    Android: "",
    Windows: undefined,
  },
  cartoonCraft: {
    id: "5cc64801-ec4b-44de-a2cc-4d18df4775db",
    quests: {
      wishlist: "wishlist",
    },
    name: "Cartoon Craft",
    shortName: "Cartoon Craft",
    ab: "/games/cartoon-craft",
    banner: undefined,
    rating: undefined,
    downloads: undefined,
    iOS: "",
    Android: "",
    Windows: undefined,
  },
  spiderTanks: {
    id: "b144a9e8-9179-4126-9471-14975e5cf5e3",
    quests: {
      wishlist: "wishlist",
    },
    name: "Spider Tanks: Cores of Chaos",
    shortName: "Spider Tanks",
    ab: "/games/spider-tanks-cores-of-chaos",
    banner: "/images/onboarding/spider-tanks.webp",
    rating: undefined,
    downloads: undefined,
    iOS: "https://apps.apple.com/us/app/spider-tanks-cores-of-chaos/id6746262642",
    Android:
      "https://play.google.com/store/apps/details?id=nl.gamedia.spidertanks",
    Windows: undefined,
  },
  nomstead: {
    id: "91a264a7-dfd9-4338-a338-18326908a6a4",
    quests: {
      wishlist: "91a264a7-dfd9-4338-a338-18326908a6a4-wishlist",
      downloadInstall: "download-install",
    },
    name: "NomStead",
    ab: "/games/nomstead",
    banner: "/images/onboarding/nomstead-banner.webp",
    rating: undefined,
    genre: ["Casual", "MMO", "Strategy"],
    downloads: undefined,
    iOS: "",
    Android: "",
    General: "https://nomstead.com",
    description: "Build a new civilization from scratch",
  },
  slimeminer: {
    id: "65e93b9e-e054-4f3a-aed8-bb5d210b0302",
    quests: {
      wishlist: "65e93b9e-e054-4f3a-aed8-bb5d210b0302-wishlist",
      loginPlayGame: "login-play-game",
      downloadPlay: "q-app-download",
    },
    name: "SlimeMiner",
    ab: "/games/slime-miner",
    banner: "/images/onboarding/slime-miner-banner.webp",
    rating: undefined,
    genre: ["Strategy", "RPG"],
    downloads: undefined,
    iOS: "https://apps.apple.com/us/app/slime-miner-saga/id6749876270",
    Android: "https://play.google.com/store/apps/details?id=io.slimeminer.app",
    description: "Uncover treasures and upgrade your slimes",
  },
  ravenIdle: {
    id: "2a91e89f-c41f-4758-89a9-f8d52310cc93",
    quests: {
      wishlist: "2a91e89f-c41f-4758-89a9-f8d52310cc93-wishlist",
      loginPlayGame: "ravenidle-link-passport",
    },
    name: "RavenIdle",
    ab: "/games/ravenidle",
    banner: "/images/onboarding/ravenidle-banner.webp",
    rating: undefined,
    genre: ["Adventure"],
    downloads: undefined,
    iOS: "",
    Android: "",
    General: "https://game.ravenidle.com/en/auth/login",
    description:
      "Make strategic decisions, optimize your progression, and watch your adventure unfold.",
  },
} satisfies Record<string, Game>;

export enum OnboardingStep {
  ONBOARDING_MODAL = "onboarding-modal",
  ONBOARDING_MODAL_FLOW = "onboarding-modal-flow",
  ONBOARDING_FLOW = "onboarding-flow",
  WELCOME_INFO = "welcome_info",
  REWARDS_POOL_INFO = "rewards_pool_info",
  MOTIVATION_SELECTOR = "motivation_selector",
  GENRE_SELECTOR = "genre_selector",
  EXPLORE_GAMES_INFO = "explore_games_info",
  DO_QUESTS_INFO = "do_quests_info",
  SEE_PROGRESS_INFO = "see_progress_info",
  FREE_ENTRY_INFO = "free_entry_info",
  FREE_ENTRY_UNLOCKED_INFO = "free_entry_unlocked_info",
  GAME_WISHLIST = "game_wishlist",
  ONBOARDING_ACTIVATION = "onboarding_activation",
}

export const ONBOARDING_CONFIG = {
  FIRST_PHASE: [
    OnboardingStep.WELCOME_INFO,
    OnboardingStep.FREE_ENTRY_INFO,
    OnboardingStep.REWARDS_POOL_INFO,
    OnboardingStep.MOTIVATION_SELECTOR,
    OnboardingStep.GENRE_SELECTOR,
    OnboardingStep.GAME_WISHLIST,
    OnboardingStep.FREE_ENTRY_UNLOCKED_INFO,
  ],
  SECOND_PHASE: [
    OnboardingStep.EXPLORE_GAMES_INFO,
    OnboardingStep.DO_QUESTS_INFO,
    OnboardingStep.SEE_PROGRESS_INFO,
  ],
} as const;

export const ONBOARDING_PHASE_CONFIG = {
  FIRST_PHASE_STEPS: ONBOARDING_CONFIG.FIRST_PHASE.length,
  SECOND_PHASE_STEPS: ONBOARDING_CONFIG.SECOND_PHASE.length,
  TOTAL_STEPS:
    ONBOARDING_CONFIG.FIRST_PHASE.length +
    ONBOARDING_CONFIG.SECOND_PHASE.length,
} as const;

export interface OnboardingStepProps {
  visible: boolean;
}

export const ONBOARDING_STARTER_QUESTS_ID =
  "11111111-1111-1111-1111-111111111111-onboarding-starter-quests";

export const ONBOARDING_STARTER_QUESTS_COMPLETED_ID =
  "11111111-1111-1111-1111-111111111111-onboarding-starter-quests-completed";
